<template>
  <div class="mx-auto w-full max-w-6xl">
    <div class="mb-16 text-center">
      <h1 class="mb-3 text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">{{ props.title }}</h1>
      <p class="text-muted-foreground">{{ props.description }}</p>
    </div>

    <div :class="computedClass">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props
const props = defineProps({
  columns: {
    type: Number,
    required: false,
    default: 3,
  },
  description: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

// Computed
const computedClass = computed(() => {
  const result = [
    "grid max-w-6xl overflow-hidden",
    `grid-cols-1`,
    `sm:grid-cols-2`,
    `lg:grid-cols-${props.columns}`, // lg:grid-cols-2, lg:grid-cols-3
    "[&>*]:relative [&>*]:px-1 [&>*]:py-12 [&>*]:before:absolute [&>*]:before:bg-border/70 [&>*]:before:[block-size:100vh] [&>*]:before:[inline-size:1px] [&>*]:before:[inset-block-start:0] [&>*]:before:[inset-inline-start:-1px] [&>*]:after:absolute [&>*]:after:bg-border/70 [&>*]:after:[block-size:1px] [&>*]:after:[inline-size:100vw] [&>*]:after:[inset-block-start:-1px] [&>*]:after:[inset-inline-start:0] sm:[&>*]:px-8 xl:[&>*]:px-12",
  ];

  return result.join(" ");
});
</script>
